var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('div',[(_vm.USER_INFO.status === 'admin')?_c('UploadProdaji',{on:{"update":_vm.update}}):_vm._e()],1),_c('div',[_c('TableStats',{key:_vm.key})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }